import React from 'react';
import { useState } from 'react';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Accordion } from 'react-bootstrap';
import {EVENT_CLASSIFICATION_GRADE_CTCAE} from '../../../utilities'
import { setRadioValue } from '../../../Redux/actions/actions';


const GradeCase = ({handleReset, radioValue, handleRadioBtn, radioReset, getEventDescId}) => {
    const dispatch = useDispatch()
    // const radioValue = useSelector((state) => state.radioValue);
    const studyAeDtls = useSelector((state) => state.getStudyAeDtls);
    const [selectedEvent, setSelectedEvent] = useState([])
    
    useEffect(() => {
        setSelectedEvent(studyAeDtls)
        getEventDescId()
    }, [dispatch, studyAeDtls, radioValue] )
    
    
    
    const handleOptionChange=(e)=>{
      handleReset('')
      setTimeout(() => {
        let value = e.target.value 
        // dispatch(setRadioValue(value))
        handleRadioBtn(value)
        let ctcaeData= selectedEvent&&selectedEvent[0]?.grade_case?.filter(elem=>elem.study_ctcae_id ===value && elem)

      let data=ctcaeData?.map(i => ({
      ...i,
      is_case_meets: EVENT_CLASSIFICATION_GRADE_CTCAE,
      event_description_id: i.study_ctcae_id,
    }));
        if(ctcaeData.length>0){
            getEventDescId(data[0])
        }
      
      }, 100);
    }

    return (
        <div className='accordion_item_cls border-0'>
        
              <Accordion defaultActiveKey={radioValue}>
                        <Accordion.Item eventKey="1" className='d-flex flex-column gap-2 bg-light'>
                          <Accordion.Header>
                            <div className="custm-radio-styl">
                              <label
                                htmlFor="gradecase"
                                style={{
                                  display: "flex",
                                  alignItems: "start",
                                  padding: "10px 0px",
                                  marginLeft:"10px",
                                  cursor:"pointer",
                                  color: radioValue ? 'green' : 'black' // Change text color
                                }}
                              >
                             
                                <h6 className="mb-0" id={'gradecase'}>Grade</h6>
                              </label>
                            </div>
                          </Accordion.Header>
                          {studyAeDtls &&
          studyAeDtls[0]?.grade_case?.map((i) => {
            return (
                                  <Accordion.Body>
                                    <div className="">
                                      <div className="custm-radio-styl d-flex flex-row gap-2">
                                        
                                          <input
                                            type="radio"
                                            id={i.study_ctcae_id}
                                            value={radioReset==='reset'?null: i.study_ctcae_id}
                                            checked={radioReset==='reset'?null: radioValue === i.study_ctcae_id}
                                            onChange={(e)=>handleOptionChange(e)}
                                            style={{
                                              width: "20px",
                                              alignSelf:"start",
                                              cursor:"pointer",
                                              marginLeft:"10px"
                                            }}
                                          />
                                          <label
                                          htmlFor={i.study_ctcae_id}
                                          style={{
                                            display: "flex",
                                            alignItems:
                                              "start",
                                            
                                          }}
                                        >{
                                              i.study_ctcae_definition
                                            }</label>
                                          {/* <span
                                            style={{
                                              marginLeft:
                                                "10px",
                                            }}
                                          > */}
                                            
                                          {/* </span> */}
                                        
                                      </div>
                                    </div>
                                  </Accordion.Body>
                                  );
          })}
                        </Accordion.Item>
                        </Accordion>
          
      </div>
    );
};

export default GradeCase;